import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberFormatPipe } from 'src/app/_pipes/number-format.pipe';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ReportProducerModule } from 'src/app/welcome/home-menu/bancassurance-services/report-producer/report-producer.module';
import { ReportManagerModule } from 'src/app/welcome/home-menu/bancassurance-services/report-manager/report-manager.module';
import { ResponsableSidebarComponent } from 'src/app/welcome/home-menu/bancassurance-responsable-menus/responsable-sidebar/responsable-sidebar.component';
import { ProducerSidebarComponent } from 'src/app/welcome/home-menu/bancassurance-producteur-menus/producer-sidebar/producer-sidebar.component';

import { NetworkStatusComponent } from './network-status.component';
import { SecureInputDirective, SecurityErrorDirective } from 'src/app/_helpers/secure-input.directive';



@NgModule({
  declarations: [NumberFormatPipe, ResponsableSidebarComponent, ProducerSidebarComponent, NetworkStatusComponent, SecureInputDirective, SecurityErrorDirective],
  exports: [NumberFormatPipe, FormsModule, TranslateModule, ReportProducerModule, ReportManagerModule, ResponsableSidebarComponent, ProducerSidebarComponent, RouterModule, NetworkStatusComponent, SecureInputDirective, SecurityErrorDirective],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReportProducerModule,
    ReportManagerModule,
    RouterModule
  ]
})
export class SharedModule { }
